function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 31,
    viewBox: "0 0 73 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75773 29.7268H0.449219V0.40558H29.5363C42.295 0.40558 44.3085 11.8673 44.3085 11.8673L51.4681 0.40558H58.9706L72.6848 22.6368L68.3886 29.7259H50.3054V26.1892H70.5315L55.2112 0.405273C55.2112 0.405273 45.1143 17.9741 42.9468 21.3967C40.7791 24.8194 36.7074 29.7251 29.7331 29.7251H18.9314V12.2695H22.3541V26.1882H30.2261C33.7074 26.1882 41.1786 23.222 41.1786 14.8366C41.1786 6.45121 33.1924 3.82721 30.5684 3.82721H3.75742V29.7244L3.75773 29.7268ZM4.8986 29.7268V17.2913H17.6764V20.714H8.32115V29.727H4.89845L4.8986 29.7268ZM17.6764 15.8081V12.2714H8.32115V8.52004H29.8483C33.0752 8.52004 36.5014 11.1304 36.5014 14.9523C36.5014 18.7742 33.0383 21.3982 30.5689 21.3982H27.2131V12.2712H23.6764V24.8209H30.5689C34.9343 24.8209 39.9811 21.0319 39.9811 15.0663C39.9811 9.15786 35.3912 5.08372 29.9026 5.08372H4.89937V15.8079H17.6771L17.6764 15.8081ZM39.5234 29.7268L55.2111 3.82965L68.103 24.8211H50.3061V21.3984H61.8289L55.2118 10.617L44.3165 29.7273H39.5248L39.5234 29.7268Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFda);
export default __webpack_public_path__ + "static/media/FDA.9c188b84f1d6be81cc18aa945f44eb94.svg";
export { ForwardRef as ReactComponent };